import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import {
  vendorSubscriptionApi,
  SubscriptionForVendorApi,
  fetchSubscribedVendorApi,
} from "../../../Services/Vendor/VendorApi/VendorApi";
import { fetchProductList } from "../../../Services/Subscription/subscriptionApi";
import { toast } from "react-toastify";

export function VendorSubscriptionModal(props) {
  // const navigate = useNavigate()
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: productList } = useSelector((state) => state.fetchProductList);
  const [productId, setProductId] = useState("");

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  useEffect(() => {
    if (productList?.data?.length > 0) {
      const product = productList.data.find(
        (item) => item.metadata.Type.name === "dir_listing"
      );
      setProductId(product ? product.id : null);
    }
  }, [productList, userType]);

  const handleSubmit = async (e) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const res = await dispatch(
        SubscriptionForVendorApi({
          user_id: userId,
          product_id: productId,
          city_id: props.id,
        })
      );
      if (res) {
        props.onHide();
        if (res?.payload?.data?.checkout_url)
          setTimeout(() => {
            window.location.href = res?.payload?.data?.checkout_url;
            const currentPage = window.location.pathname;
            localStorage.setItem("lastVisitedPage", currentPage);
          }, 500);
        else if (res?.payload?.status === 200) {
          toast.success(res?.payload?.message);
        } else {
          toast.error(res?.payload?.message);
        }
        dispatch(fetchSubscribedVendorApi(userId));
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false); // Unlock the button
    }
  };
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title className="fw-bold">Confirm Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <p className="text-muted">Are you sure you want to subscribe?</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <button className="bttn-close" onClick={props.onHide}>
          Cancel
        </button>
        <button className="bttn-upload" onClick={() => handleSubmit()}>
          {isSubmitting ? "Loading..." : "Subscribe"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

const PurchaseSubscriptionModal = (props) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: productList } = useSelector((state) => state.fetchProductList);
  const [productId, setProductId] = useState("");

  useEffect(() => {
    dispatch(fetchProductList());
  }, [dispatch]);

  useEffect(() => {
    if (productList?.data?.length > 0) {
      const product = productList.data.find(
        (item) => item.metadata.Type.name === "ad_banner"
      );
      setProductId(product ? product.id : null);
    }
  }, [productList, userType]);

  const handleSubmit = async (e) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      const res = await dispatch(
        vendorSubscriptionApi({
          user_id: userId,
          product_id: productId,
          city_id: props.id,
        })
      );
      if (res) {
        props.onHide();
        if (res?.payload?.status === 200) props.fetchSubscription();
        if (res?.payload?.data?.checkout_url)
          setTimeout(() => {
            window.location.href = res?.payload?.data?.checkout_url;
            const currentPage = window.location.pathname;
            localStorage.setItem("lastVisitedPage", currentPage);
          }, 500);
        else if (res?.payload?.status === 200) {
          toast.success(res?.payload?.message);
        } else {
          toast.error(res?.payload?.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false); // Unlock the button
    }
  };
  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="d-flex justify-content-center">
        <Modal.Title className="fw-bold">Confirm Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <p className="text-muted">Are you sure you want to subscribe?</p>
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <button className="bttn-close" onClick={props.onHide}>
          Cancel
        </button>
        <button className="bttn-upload" onClick={() => handleSubmit()}>
          {isSubmitting ? "Loading..." : "Subscribe"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PurchaseSubscriptionModal;
